import { createElement } from "react";
import { render } from "react-dom";
import App from "./App";
function main() {
    var app = createElement(App, {});
    var host = document.getElementById("host");
    render(app, host);
}
main();
